import React, { useEffect, useCallback } from "react"
import { reduxForm, submit, reset } from "redux-form"
import { connect } from "react-redux"
import { Box } from "@infotech/uikit-grid"
import FieldSet from "@infotech/uikit-fieldset"
import FilterModal from "src/components/FilterModal"
import get from "lodash/get"
import { ResourceTypesField } from "../Item"

const FORM_NAME = `resourceFilter`

const ResourceFilterFormComponent = props => {
  const { isOpen, dirty, onCancel, dispatch, query, modelName } = props
  const handleSubmit = () => {
    dispatch(submit(FORM_NAME))
  }

  const resetForm = useCallback(() => dispatch(reset(FORM_NAME)), [])

  const handleCancel = useCallback(() => {
    resetForm()
    onCancel()
  }, [])

  useEffect(() => {
    if (!query) {
      resetForm()
    }
  }, [query])

  return (
    <FilterModal
      modelName={modelName}
      isOpen={isOpen}
      onOk={handleSubmit}
      onCancel={handleCancel}
      width={440}
      dirty={dirty}
      invalid={false}
      title="Фильтр ресурсов"
    >
      <Box p="2md">
        <form>
          <FieldSet caption="Тип ресурса">
            <ResourceTypesField />
          </FieldSet>
        </form>
      </Box>
    </FilterModal>
  )
}

const queryToValues = rsqlQuery => {
  if (!rsqlQuery) {
    return undefined
  }
  const resourceTypeIdRegex = /resourceTypeId=in=\(.*\)/gi
  const resourceTypeIdRsqlString = get(
    rsqlQuery.match(resourceTypeIdRegex),
    `[0]`,
    ``,
  )
  const resourceTypeId = resourceTypeIdRsqlString.length
    ? parseInt(
        resourceTypeIdRsqlString.substring(
          19,
          resourceTypeIdRsqlString.length - 1,
        ),
        10,
      )
    : undefined
  return {
    resourceTypeId,
  }
}

const valuesToQuery = values => {
  if (values.resourceTypeId) {
    return `resourceTypeId=in=(${values.resourceTypeId})`
  }
  return ``
}

const ResourceFilterForm = reduxForm({
  onSubmit: (values, dispatch, props) => {
    props.onOk(valuesToQuery(values))
  },
  enableReinitialize: true,
  form: FORM_NAME,
})(ResourceFilterFormComponent)

const ConnectedResourceFilterForm = connect(
  (state, props) => ({
    initialValues: queryToValues(props.query),
  }),
  null,
)(ResourceFilterForm)

export default ConnectedResourceFilterForm
